import React from "react";
import { NavLink } from "react-router-dom";

const Cta = (props) => {
  return (
    <>
      <section className="cta-wrapper">
        <div className="max-container">
          <div className="padd-90">
            <div className="text-center">
              <h2 className="text-white roboto-bold mb30 heading29px">
                {props.heading}
              </h2>
              <ul className="btn-sec">
                <li>
                  <NavLink
                    to={props.firstCta}
                    className="common-btn-class main-btn-secondry roboto-regular"
                    style={{ color: "#1d1e1f" }}
                  >
                    {props.firstCtaText}{" "}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={props.secondCta}
                    className="common-btn-class transparentBtn roboto-regular"
                    style={{
                      backgroundColor: "transparent",
                      borderColor: "#fff",
                      color: "#fff",
                    }}
                  >
                    {props.secondCtaText}
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Cta;
